import ProductTabContentTagsComponent from "./product-tab-content-tags-component";
import { componentStyles } from "./product-tab-content-component.scss";
import AssetComponent from "components/core/asset/asset-component";

const ProductTabContentComponent = ({ content, productType }) => {
  return (
    <div className="product-tab-content">
      {content?.productTags && <ProductTabContentTagsComponent tags={content.productTags} productType={productType} />}
      <div className="asset-container">{content?.asset && <AssetComponent {...content.asset} />}</div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default ProductTabContentComponent;
